import { Component, OnInit, OnDestroy } from '@angular/core';
import { ToasterService } from '../../services/toaster.service';
import { AlertInfo } from '../../interface/alert-message';

@Component({
  selector: 'app-alert-info',
  imports: [],
  templateUrl: './alert-info.html',
  styleUrl: './alert-info.scss',
})
export class AlertInfoComponent implements OnInit, OnDestroy {

  constructor(
    private toasterService: ToasterService
  ) { }


  show: boolean = false;
  showModel: boolean = false;

  statusSubscription: any;
  alertInfo!: AlertInfo;

  resolve: any;

  ngOnInit(): void {
    this.statusSubscription = this.toasterService.alertTrigger$.subscribe((val) => {
      if (!val) return;
      this.resolve = val.resolve;
      this.show = true;
      this.showModel=true;
      this.alertInfo = val;
      document.body.classList.add('modal-open');
    });
  }

  close() {
    this.resolve(true);
    this.showModel=false;
    setTimeout(() => {
      this.show = false;
      document.body.classList.remove('modal-open');
    }, 200);
  }

  ngOnDestroy(): void {
    this.statusSubscription.unsubscribe();
  }
}
